/**
 * INDEX.JS | THE STRUCTURAL FOUNDATION
 * ROLE: Initializing Global Infrastructure & Forensic Session Handshake.
 * VERSION: 10.3.3 (Build 2026.06.30 - Gateway Alignment)
 * FIRM: Micheals Infrastructure Advisory
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css'; 

/**
 * FORENSIC SESSION INITIALIZATION
 * Uses sessionStorage to ensure state isolation per browser tab.
 */
const initializeForensicSession = () => {
    if (typeof window === 'undefined') return null;

    let sessionId = sessionStorage.getItem('session_id');
    
    const isInvalid = !sessionId || 
                      ['undefined', 'null', '', 'NaN', '[object Object]'].includes(String(sessionId).trim());
    
    if (isInvalid) {
        const entropy = Math.random().toString(36).substring(2, 15) + 
                        Math.random().toString(36).substring(2, 10);
        const timestamp = Date.now();
        sessionId = `med_auth_${entropy}_${timestamp}`;
        
        sessionStorage.setItem('session_id', sessionId);
    }
    
    // Global injection for socket hooks
    window.AVA_SESSION_ID = sessionId;
    
    console.log(
        `%c [MED_INIT] %c SESSION_ID: ${sessionId} %c STATUS: STABLE `,
        'background: #1c1917; color: #f59e0b; font-weight: bold; padding: 2px 4px; border-radius: 2px 0 0 2px;',
        'background: #262626; color: #a3a3a3; padding: 2px 4px;',
        'background: #1c1917; color: #10b981; font-weight: bold; padding: 2px 4px; border-radius: 0 2px 2px 0;'
    );

    return sessionId;
};

const activeSession = initializeForensicSession();
const rootElement = document.getElementById('root');

if (!rootElement) {
    console.error("❌ [MED_CRITICAL_FAILURE]: Root mounting point (#root) missing.");
} else {
    const root = ReactDOM.createRoot(rootElement);
    
    root.render(
      <React.StrictMode>
        <HelmetProvider>
          <BrowserRouter>
            {/* The key={activeSession} ensures a full re-render on session transition */}
            <App key={activeSession} sessionId={activeSession} />
          </BrowserRouter>
        </HelmetProvider>
      </React.StrictMode>
    );
}